<template>
  <div class="step-card" :class="customClass" :style="animationStyle">
    <div class="step-number" v-if="number">{{ number }}</div>
    <div class="step-icon" v-if="icon">
      <i :class="icon"></i>
    </div>
    <h4 class="step-title" v-if="title">{{ title }}</h4>
    <p class="step-text" v-if="text">{{ text }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "StepCard",
  props: {
    number: {
      type: [String, Number],
      default: null
    },
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    animationDelay: {
      type: Number,
      default: 0
    },
    customClass: {
      type: String,
      default: "animate-on-scroll fade-in-up"
    }
  },
  computed: {
    animationStyle() {
      return this.animationDelay > 0 
        ? { 'animation-delay': `${this.animationDelay}s` }
        : {};
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.step-card {
  background: white;
  padding: 2.5rem;
  border-radius: 15px;
  text-align: center;
  position: relative;
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px $landing-primary-rgba-10;
  }
  
  .step-number {
    width: 60px;
    height: 60px;
    background: $landing-primary-gradient;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    font-size: 2rem;
    font-weight: 700;
    color: white;
  }
  
  .step-icon {
    width: 80px;
    height: 80px;
    background: $landing-primary-gradient;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1rem auto 1.5rem;
    transition: all 0.3s ease;
    
    i {
      font-size: 2rem;
      color: white;
    }
  }
  
  &:hover .step-icon {
    transform: scale(1.1) rotate(5deg);
  }
  
  .step-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #2D4A4D;
    margin-bottom: 1rem;
  }
  
  .step-text {
    color: #2D4A4D;
    line-height: 1.7;
  }
}
</style>
